import { defineStore } from "pinia";

export const useUpdatesStore = defineStore("updates", {
  state: () => ({
    appSelectionId: false,
    datacenterVersion: null
  }),

  getters: {
    getAppSelectionId(state) {
      return state.appSelectionId;
    },
    getDatacenterVersion(state) {
      return state.datacenterVersion;
    }
  },

  actions: {
    setAppSelectionId(payload) {
      this.appSelectionId = payload;
    },
    setDatacenterVersion(payload) {
      this.datacenterVersion = payload;
    }
  }
});
